import { useCallback, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { getCampaignsAPI, putUpdateVouchersAPI } from "api/campaign-voucher";
import { VoucherUpdateFormTypes } from "schemas/campaign-voucher-schemas";
import { QUERY_KEYS } from "constants/querykeys";
import { DropDownItem } from 'types/components'

export const useVouchersQuery = () => {
  const queryKey = [QUERY_KEYS.VOUCHER_LIST]
  const queryFn = async () => {
    return await getCampaignsAPI()
  }
  const queryOptions = {
    refetchOnWindowFocus: false,
    queryKey,
    queryFn,
  }
  const query = useQuery(queryOptions)

  return {
    query,
  }
}

export const useVouchersMutation = () => {
  const { mutateAsync } = useMutation({
    mutationFn: getCampaignsAPI,
    mutationKey: [QUERY_KEYS.REPORT_MERCHANT_SEARCH],
    onMutate: () => {
      // console.log('loading ...')
    },
    onSuccess: () => {
      // console.log('success')
    },
    onError: () => {
      // console.log('error')
    },
  })

  const onSearchVouchersLoader = useCallback(
    async (inputValue: string) => {
      if (inputValue.length < 3) return []
      const data = await mutateAsync()
      const options = data.data.map((item) => ({
        label: String(item.campaignName),
        value: String(item.campaignId),
      }))
      return options
    },
    [mutateAsync]
  )

  return {
    onSearchVouchersLoader,
  }
}

export const useVouchersSelectQuery = () => {
  const [selectedVouchers, selectedVouchersSet] = useState<DropDownItem[]>([])

  const onSelectVouchers = useCallback(
    (campaign: DropDownItem) => {
      if (!campaign) return
      const isExist = selectedVouchers.find(
        (item) => item.value === campaign?.value
      )
      if (!isExist) selectedVouchersSet([...selectedVouchers, campaign])
      if (isExist)
        selectedVouchersSet(
          selectedVouchers.filter((item) => item.value !== campaign.value)
        )
    },
    [selectedVouchers, selectedVouchersSet]
  )

  return {
    selectedVouchers,
    onSelectVouchers,
  }
}

export const useVoucherUpdate = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (mutationData: { formData: VoucherUpdateFormTypes }) => {
      return putUpdateVouchersAPI(mutationData.formData)
    },
    onError: (error: string) => {
      console.error('Voucher update error:', error)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === QUERY_KEYS.VOUCHER_LIST
      })
    },
  })

  return mutation
}